import { OrNull } from '..';

const ignoredTriplePlay: string[] = ['field_738', 'heading1100'];

export const excludeDependency = (
  name: string,
  type?: OrNull<string | undefined>
) => {
  if (!type) {
    return false;
  }

  if (type.includes('TriplePlay')) {
    return ignoredTriplePlay.includes(name);
  }

  return false;
};
